export const loadNewValueLottoResultCleanupDelay = 7000;
export const mainGameCheckTimeout = 2500;